<script lang="ts">
    import {_} from 'svelte-i18n'
    import type {Conversation, Session} from './types';
    import {Role} from './types';
    import ConversationComponent from './Conversation.svelte';
    import {conversations, currentConversation, paths, walker} from './services';
    import {assert} from './service/util';
    import {get} from 'svelte/store';

    export let session: Session;

    async function endConversation(conversationEvt: CustomEvent<Conversation>) {
        assert(session.roles.includes(Role.OPERATOR))
        await conversations.endConversation(conversationEvt.detail, session);
        await walker.goTo(get(paths).home);
    }

    async function closeConversation() {
        await walker.goTo(get(paths).home);
    }

    async function startConversation(conversationEvt: CustomEvent<Conversation>) {
        await conversations.startConversation(conversationEvt.detail, session);
    }

    async function pauseConversation(conversationEvt: CustomEvent<Conversation>) {
        await conversations.pauseConversation(conversationEvt.detail);
    }

    async function unpauseConversation(conversationEvt: CustomEvent<Conversation>) {
        await conversations.unpauseConversation(conversationEvt.detail);
    }
</script>

{#if $currentConversation}
    <ConversationComponent session={session}
                           conversation={$currentConversation}
                           on:conversation-start={startConversation}
                           on:conversation-close={closeConversation}
                           on:conversation-end={endConversation}
                           on:conversation-pause={pauseConversation}
                           on:conversation-unpause={unpauseConversation} />
{:else}
    <div style="display: flex; flex-direction: column; align-items: center; text-align: center; justify-content: center; margin: 30px 0">
        <div class="mdc-typography--headline4" style="margin: 5px 0; padding: 5px 0">Kde nic tu nic</div>
        <div class="mdc-typography--body1" style="max-width: 800px; text-align: left;">
            {$_('chat.ChatProbablyEndedLongTimeAgo')}<br/>
            {$_('commons.youCanReturnTo')} <a href={$paths.home}>{$_('commons.homePageTo')}</a>
        </div>
    </div>
{/if}
